var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileNotch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240 384H144C135.164 384 128 391.162 128 400C128 408.836 135.164 416 144 416H240C248.838 416 256 408.836 256 400C256 391.162 248.838 384 240 384ZM288 0H96C51.818 0 16 35.816 16 80V432C16 476.182 51.818 512 96 512H288C332.184 512 368 476.182 368 432V80C368 35.816 332.184 0 288 0ZM304 432C304 440.822 296.822 448 288 448H96C87.178 448 80 440.822 80 432V80C80 71.178 87.178 64 96 64H128V80C128 88.836 135.164 96 144 96H240C248.838 96 256 88.836 256 80V64H288C296.822 64 304 71.178 304 80V432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNotch);
export default __webpack_public_path__ + "static/media/mobile-notch.bea1e49bef8d0b48550029cbaba6bb8b.svg";
export { ForwardRef as ReactComponent };